<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item.name}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div class="metter" v-if="trainData.length!==0">
      <el-table ref="JLTable" :data="trainData" border style="width:100%">
        <el-table-column prop="title" label="名称" align="left" show-overflow-tooltip min-width="280">
          <template slot-scope="scope">
            <span
              type="primary"
              size="mini"
              class="title1deta"
              style="  "
              @click="trainclass(scope.row.id)"
            >{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          min-height="140px"
          :label="'类别'"
          prop="catedicname"
          show-overflow-tooltip
          align="center"
        ></el-table-column>

        <el-table-column min-height="140px" width="100px" :label="'开始时间'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.startime.substring(0, 10) }}</span>
          </template>
        </el-table-column>
        <el-table-column min-height="140px" width="100px" :label="'结束时间'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.endtime.substring(0, 10) }}</span>
          </template>
        </el-table-column>
        
        <el-table-column
          width="80px"
          min-height="140px"
          :label="'状态'"
          prop="stateName"
          align="center"
        ></el-table-column>

        <el-table-column
          align="center"
          :label="'操作'"
          width="200"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" plain size="small" @click="trainclass(scope.row.id)">详情</el-button> -->
            <!-- <el-button type="primary" plain size="mini" @click="passTrain(scope.row)">免训申请</el-button> -->
            <el-button type="primary" :disabled="scope.row.isover==false" @click.prevent="toPrinting(scope.row)" plain size="mini">训历档案</el-button>
            <el-button type="primary" plain size="mini" @click="trainScore(scope.row.id)">成绩</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="listQuery.limit"
        layout="total,sizes, prev, pager, next"
        :total="trainCount"
        v-if="trainCount"
      ></el-pagination>
    </div>
    <el-dialog
      title="免训申请"
      :visible.sync="passDialog"
      width="30%"
      destroy-on-close
      v-if="passDialog"
    >
      <el-form ref="tempRef" :model="passObj" :rules="passRules" label-width="80px">
        <el-form-item label="申请理由" prop="cause">
          <el-input type="textarea" :rows="2" placeholder="请输入理由" v-model="passObj.cause" clearable></el-input>
        </el-form-item>
        <el-form-item label="上传文件">
          <div style="display:flex">
            <el-upload
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="activityFileHandleRemove"
              :on-success="activitysuccess"
              multiple
              v-model="passObj.fileUrl"
              :accept="accept"
              :limit="1"
              :show-file-list="false"
            >
              <el-button type="primary">上传</el-button>
            </el-upload>
            <el-button
              style="margin-left: 10px;"
              v-if="passObj.fileUrl"
              @click="activityFileHandleLook"
            >查看</el-button>
            <!-- <el-button v-if="passObj.fileUrl" @click="activityFileHandleRemove">移除</el-button> -->
          </div>
        </el-form-item>
        <div v-if="dataState">
          <span>审核状态：</span>
          <span v-if="passObj.passStatus==1" style="color: green;">通过</span>
          <span v-if="passObj.passStatus==0">审核中</span>
          <span v-if="passObj.passStatus==-1" style="color: red;">不通过</span>
        </div>
        <div style="margin-top: 10px;" v-if="dataState">
          <span>通过理由：</span>
          <span v-if="passObj.passReason">{{passObj.passReason}}</span>
          <span v-else>无</span>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passDialog = false">取 消</el-button>
        <el-button v-if="!dataState" type="primary" @click="subPassDialog">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="40%"
      title="准入测试内容"
      :visible.sync="innerVisible"
      :show-close="false"
      center
      append-to-body
    >
      <TestContent v-if="innerVisible" :trainId="trainId"></TestContent>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="innerVisible = false">返回</el-button>
      </span>
    </el-dialog>

    <el-dialog width="800px" title="我的成绩" :visible.sync="scoreDialog" center>
      <el-table
        ref="mainTable"
        :key="tableKey"
        :data="trainScoreData"
        border
        fit
        highlight-current-row
        style="width: 100%;"
        :cell-style="{'text-align':'center'}"
      >
        <el-table-column
          align="center"
          :label="item"
          :prop="item"
          min-width="100"
          v-for="(item,index) in getColumnName"
          :key="index"
        ></el-table-column>

        <!-- <el-table-column class-name="status-col" :label="'综合分数'" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.score}}</span>
          </template>
        </el-table-column>-->

        <el-table-column :label="'培训结果'" min-width="100" align="center" prop="state"></el-table-column>
      </el-table>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="scoreDialog = false">关闭</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>
<script>
import * as Personcenter from '@/api/personcenter/index';
import * as apiTrain from '@/api/train/index';
import TestContent from '../../train/trainclass/compoents/testContent.vue';
export default {
  components: {
    TestContent,
  },

  data() {
    return {
      tableKey: 0,
      getColumnName: [],
      labledata: [
        { name: '全部', id: 0 },
        { name: '未开始', id: 1 },
        { name: '进行中', id: 2 },
        { name: '已结束', id: 3 },
      ],
      currentPage2: 1,
      listQuery: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
        type: 0,
      },
      passObj: {
        cause: '',
        passReason: '',
        fileUrl: '',
      },
      passDialog: false,
      passRules: {
        cause: [{ required: true, message: '请输入申请理由', trigger: 'blur' }],
      },
      lableindex: 0,
      trainData: [],
      trainCount: 0,
      dataState: true,
      trainId: 0,
      innerVisible: false,
      temp: {
        contents: '',
      },
      accept: '.ppt,.pdf,.pptx,.doc,.docx,.xls,.xlsx',
      scoreDialog: false,
      trainScoreData: [],
    };
  },
  created() {
    this.getListTrain();
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  methods: {
    activityFileHandleRemove(file, fileList) {
      this.passObj.fileUrl = '';
      this.$message.success('移除成功');
    },
    activitysuccess(response, file, fileList) {
      this.passObj.fileUrl = response.result;
      this.$message.success('上传成功');
    },
    activityFileHandleLook() {
      if (this.passObj.fileUrl == '') {
        this.$notify({
          title: '失败',
          message: '没有文件可查看',
          type: 'warning',
        });
      } else {
        //下载文件
        window.open(this.passObj.fileUrl);
      }
    },
    //立即测试
    testNow(item) {
      this.trainId = item.id;
      this.innerVisible = true;
    },
    subPassDialog() {
      let data = {
        userId: this.$store.state.User.ids,
        trainId: this.trainId,
        passStatus: 0,
        cause: this.passObj.cause,
        fileUrl: this.passObj.fileUrl,
      };
      let _this = this;
      _this.$refs['tempRef'].validate((valid) => {
        if (valid) {
          apiTrain.addPass(data).then((res) => {
            if (res.code == 200) {
              this.$message.success('添加免训申请成功！');
              this.passDialog = false;
            }
          });
        }
      });
    },
    //免训申请
    passTrain(item) {
      this.trainId = item.id;
      this.passObj = {};
      // this.passObj=item
      let para = {
        userId: this.$store.state.User.ids,
        trainId: item.id,
      };
      apiTrain.getFree(para).then((res) => {
        if (res.result == null) {
          this.dataState = false;
        } else {
          this.passObj = res.result;
          this.dataState = true;
        }
      });
      this.passDialog = true;
    },
    lableArea(index, item) {
      this.lableindex = index;
      this.listQuery.type = item.id;
      this.listQuery.page = 1;
      this.getListTrain();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getListTrain();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getListTrain();
    },
    trainCourse(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
          labelIndex: 2,
        },
      });
    },
    trainDay(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
          labelIndex: 1,
        },
      });
    },
    trainScore(id) {
      this.scoreDialog = true;
      let para = {
        userId: this.$store.state.User.ids,
        trainId: id,
      };
      Personcenter.getUserScoreByUserId(para).then((res) => {
        this.trainScoreData = res.data;
      });
      apiTrain.getColumnName({ trainId: id }).then((res) => {
        this.getColumnName = res.result;
      });
    },
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    getListTrain() {
      Personcenter.TrainInfoGetMyTrain(this.listQuery).then((res) => {
        this.trainData = res.data;

        this.trainCount = res.count;
      });
    },
    //去打印页面
    toPrinting(item){
      if(!item.isover){
        return false
      }
      
      window.open('/userArchives?trainId=' + item.id + '&userId=' + this.$store.state.User.ids);
    }
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  /* width: 850px; */
  /* display: flex;
  flex-wrap: wrap; */
}

.nav {
  width: 800px;
  height: 180px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  /* box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */

  border: 1px solid #f2f2f2;
  /* padding-left: 16px; */
  padding-top: 16px;
  margin-left: 20px;
}
/* .nav:hover{
    box-shadow:  2px 2px 5px rgba(52, 194, 250, 0.969)!important
} */
.navfirst {
  font-weight: 700;
  padding: 0 20px;
  font-size: 16px;
  border-bottom: solid 1px #f2f2f2;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
hr {
  margin-top: 10px;
}
.navsecond {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  border-bottom: solid 1px #f2f2f2;
  padding-bottom: 10px;
}
.navsecond > div {
  line-height: 50px;
  width: 370px;
  /* text-align: center; */
  padding-left: 20px;
  color: #666;
  font-size: 14px;
}
.navthirt {
  padding-top: 10px;
  padding-left: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}

.title1deta:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #1492ff;
}
</style>